export default __webpack_public_path__ + "static/tv-76ef36772a2d4db1c4245b7b5bc03a2e.svg";